<ng-container [ngSwitch]="editMode">
  <div *ngSwitchCase="true" class="add-client-form-wrapper">
    <app-form-master
      *ngIf="form"
      [form]="form"
      [ngClass]="{
        'prevent-edit-client':
          preventEditExistingClient && reference?.hasValue()
      }"
      class="form-master-wrapper"
      (submitForm)="saveDocumentClient()"
    >
      <div class="fieldset-wrapper" (click)="clearExistingClient($event)">
        <fieldset>
          <app-input-field
            class="form-row field"
            [label]="'LABEL.CLIENT_NAME' | translate"
            fieldId="client_name_field"
            e2eId="add-client-edit-name"
            [placeholder]="
              'PLACEHOLDER.ENTER_CLIENT_NAME_OR_SEARCH_CLIENTS' | translate
            "
            [fieldControl]="form.get(formKeys.NAME)"
            [condensed]="condensed"
            [focusableTrigger$]="nameFocusableTrigger$"
            [options]="autoCompleteOptions[formKeys.NAME]"
            [rightIcon]="
              (fetchingResults$ | async) === formKeys.NAME
                ? loadingSpinnerIcon
                : null
            "
            [trackingObject]="trackingObject"
            [trackingAction]="billingNameTapped"
            (onAutoCompleteFetchStart)="onAutoCompleteFetchStart(formKeys.NAME)"
            (onAutoCompleteFetchEnd)="
              onAutoCompleteFetchEnd(formKeys.NAME, $event)
            "
            (onAutoCompleteSet)="onAutoCompleteSet($event)"
            (onAutoCompleteHide)="clearAutoCompleteOptions()"
            (onAutoCompleteDestroy)="clearSearchLoadingSpinner()"
          >
          </app-input-field>

          <app-input-field
            class="form-row field"
            [label]="'LABEL.MOBILE' | translate"
            fieldId="mobile_field"
            e2eId="add-client-edit-mobile"
            [placeholder]="'PLACEHOLDER.ENTER_MOBILE_NUMBER' | translate"
            [fieldControl]="form.get(formKeys.MOBILE)"
            [condensed]="condensed"
            [options]="autoCompleteOptions[formKeys.MOBILE]"
            [rightIcon]="
              (fetchingResults$ | async) === formKeys.MOBILE
                ? loadingSpinnerIcon
                : null
            "
            [trackingObject]="trackingObject"
            [trackingAction]="mobileTapped"
            (onAutoCompleteFetchStart)="
              onAutoCompleteFetchStart(formKeys.MOBILE)
            "
            (onAutoCompleteFetchEnd)="
              onAutoCompleteFetchEnd(formKeys.MOBILE, $event)
            "
            (onAutoCompleteSet)="onAutoCompleteSet($event)"
            (onAutoCompleteHide)="clearAutoCompleteOptions()"
            (onAutoCompleteDestroy)="clearSearchLoadingSpinner()"
          >
          </app-input-field>

          <div
            *ngFor="
              let emailFormControl of emailFormArray.controls;
              index as pos;
              count as length
            "
            class="form-row email-wrapper"
            [ngClass]="{
              'has-error':
                emailFormArray.errors?.maxlength || emailFormControl.invalid
            }"
          >
            <ng-container
              *ngIf="pos === 0 || !enableMultipleEmails; else secondaryEmail"
            >
              <app-input-field
                class="field"
                [label]="'LABEL.EMAIL' | translate"
                [placeholder]="'PLACEHOLDER.ENTER_EMAIL_ADDRESS' | translate"
                [fieldControl]="emailFormControl"
                [condensed]="condensed"
                [options]="autoCompleteOptions[formKeys.EMAIL]"
                [rightIcon]="
                  (fetchingResults$ | async) === formKeys.EMAIL
                    ? loadingSpinnerIcon
                    : null
                "
                [trackingObject]="trackingObject"
                [trackingAction]="emailTapped"
                fieldId="email_field_{{ pos }}"
                e2eId="add-client-edit-email-{{ pos }}"
                (onAutoCompleteFetchStart)="
                  onAutoCompleteFetchStart(formKeys.EMAIL)
                "
                (onAutoCompleteFetchEnd)="
                  onAutoCompleteFetchEnd(formKeys.EMAIL, $event)
                "
                (onAutoCompleteSet)="onAutoCompleteSet($event)"
                (onAutoCompleteHide)="clearAutoCompleteOptions()"
                (onAutoCompleteDestroy)="clearSearchLoadingSpinner()"
              >
              </app-input-field>

              <button
                *ngIf="enableMultipleEmails && !preventEditExistingClient"
                type="button"
                class="add-email-action"
                [disabled]="length >= 10 || emailFormArray.invalid"
                trackable
                [trackingObject]="trackingObject"
                [trackingAction]="addAdditionalEmailTapped"
                (click)="addEmailField($event)"
              >
                <app-icon
                  class="add-email-icon"
                  [icon]="addEmailIcon"
                ></app-icon>
              </button>
            </ng-container>

            <ng-template #secondaryEmail>
              <app-input-field
                class="field"
                [label]="''"
                [placeholder]="'PLACEHOLDER.ENTER_EMAIL_ADDRESS' | translate"
                [fieldControl]="emailFormControl"
                [condensed]="condensed"
                [trackingObject]="trackingObject"
                [trackingAction]="additionalEmailTapped"
                fieldId="email_field_{{ pos }}"
                e2eId="add-client-edit-email-{{ pos }}"
              >
              </app-input-field>

              <button
                *ngIf="enableMultipleEmails && !preventEditExistingClient"
                type="button"
                class="delete-email-action"
                trackable
                [trackingObject]="trackingObject"
                [trackingAction]="removeAdditionalEmailTapped"
                (click)="deleteEmail($event, pos)"
              >
                <app-icon
                  class="delete-email-icon"
                  [icon]="deleteEmailIcon"
                ></app-icon>
              </button>
            </ng-template>
          </div>

          <app-address-field
            class="form-row field"
            [label]="'LABEL.BILL_TO' | translate"
            [placeholder]="'PLACEHOLDER.ENTER_ADDRESS' | translate"
            [fieldControl]="form.get(formKeys.BILLING_ADDRESS)"
            [condensed]="condensed"
            [maxlength]="250"
            [featureToggles]="featureToggles"
            [locationInfo]="locationInfo"
            [accountCountry]="accountSettings?.companySettings.country"
            [trackingObject]="trackingObject"
            [trackingAction]="billingAddressTapped"
            [trackingScreenName]="trackingScreenName"
            fieldId="billing_address_field"
            e2eId="add-client-edit-billing-address"
          >
          </app-address-field>

          <ng-container *ngIf="documentSettings.showShipping && enableShipping">
            <app-toggle-field
              class="form-row same-shipping-billing-checkbox"
              [label]="'LABEL.USE_BILLING_ADDRESS_FOR_SHIPPING' | translate"
              fieldId="use_billing_for_shipping_field"
              [fieldControl]="form.get(formKeys.USE_SAME_BILLING_SHIPPING)"
              [trackingObject]="trackingObject"
              trackingIdentifier="billing_address_for_shipping"
              [trackingScreenName]="trackingScreenName"
            >
            </app-toggle-field>

            <ng-container
              *ngIf="!form.get(formKeys.USE_SAME_BILLING_SHIPPING).value"
            >
              <app-address-field
                class="form-row field shipping-address-field-wrapper"
                [label]="'LABEL.SHIPPING_ADDRESS' | translate"
                fieldId="shipping_address_field"
                [placeholder]="'PLACEHOLDER.ENTER_SHIPPING_ADDRESS' | translate"
                [fieldControl]="form.get(formKeys.SHIPPING_ADDRESS)"
                [condensed]="condensed"
                [featureToggles]="featureToggles"
                [locationInfo]="locationInfo"
                [accountCountry]="accountSettings?.companySettings.country"
                [maxlength]="250"
                [trackingObject]="trackingObject"
                [trackingAction]="shippingAddressTapped"
                [trackingScreenName]="trackingScreenName"
              >
              </app-address-field>
            </ng-container>

            <button
              type="button"
              class="form-row shipping-info-toggle-action"
              trackable
              [trackingObject]="trackingObject"
              [trackingAction]="addShippingTapped"
              (click)="onAddShippingInfo()"
            >
              {{ 'ACTION.ADD_SHIPPING_INFO' | translate }}
            </button>
          </ng-container>
        </fieldset>
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="form-action secondary-action"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="secondaryTrackingAction || deleteClientTapped"
          (click)="onSecondaryActionClick()"
        >
          {{ secondaryAction || ('ACTION.DELETE' | translate) }}
        </button>

        <button
          type="button"
          class="form-action save-action"
          trackable
          data-e2e-id="add-client-save-action"
          [trackingObject]="trackingObject"
          [trackingAction]="saveClientTapped"
          [disabled]="form.invalid || (fetchingResults$ | async)"
          (click)="saveDocumentClient()"
        >
          {{ 'ACTION.SAVE_CLIENT' | translate }}
        </button>
      </div>
    </app-form-master>
  </div>

  <div
    *ngSwitchDefault
    [ngSwitch]="billing?.hasValue()"
    (click)="toggleForm(true)"
  >
    <div
      *ngSwitchCase="true"
      class="client-info-wrapper"
      data-e2e-id="client-info-wrapper"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="editClientTapped"
    >
      <div class="client-info">
        <strong *ngIf="billing.name" class="billing-name">
          {{ billing.name }}
        </strong>

        <span *ngIf="billing.email" class="billing-email">
          {{ billing.email }}
        </span>
      </div>

      <button
        *ngIf="!preventDeleteClient"
        type="button"
        class="secondary-action"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="deleteClientTapped"
        (click)="deleteClient($event)"
      >
        {{ 'ACTION.DELETE' | translate }}
      </button>
    </div>

    <ng-container *ngSwitchDefault>
      <button
        type="button"
        class="add-client-action primary-action"
        data-e2e-id="add-client-action"
        trackable
        [trackingObject]="trackingObject"
        [trackingAction]="addClientTapped"
      >
        <div class="add-client-actions-contents">
          <app-icon class="add-client-icon" [icon]="addClientIcon"></app-icon>
          {{ 'ACTION.ADD_CLIENT' | translate }}
        </div>
      </button>
    </ng-container>
  </div>
</ng-container>
